import { getParameters } from '../services/parameters'
import moment from 'moment'
import store from '../store'
import { v4 as uuid } from 'uuid'
import axios from 'axios'

let events = []
let initDone = false
let lastEventFlush = moment().toDate()
let maxEventsBatchAnalytics = 10
let maxEventsTimeMinutesBatchAnalytics = 1
const urlAnalytics = `${process.env.VUE_APP_BACKEND_URL}/analytics`
let analyticsApi = null

async function initTracking() {
  analyticsApi = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
  const parameters = await getParameters([
    `/${process.env.VUE_APP_FEATURE_STAGE}/max-events-analytics`,
    `/${process.env.VUE_APP_FEATURE_STAGE}/max-events-analytics-time-minutes`
  ])
  maxEventsBatchAnalytics = Number(
    parameters.find(
      x =>
        x.name == `/${process.env.VUE_APP_FEATURE_STAGE}/max-events-analytics`
    ).value
  )
  maxEventsTimeMinutesBatchAnalytics = Number(
    parameters.find(
      x =>
        x.name ==
        `/${process.env.VUE_APP_FEATURE_STAGE}/max-events-analytics-time-minutes`
    ).value
  )
  initDone = true
}

function guid() {
  return uuid()
}
export async function trackEvent(eventType, payload, immediate = false) {
  if (!initDone) await initTracking()
  const storageToken = localStorage.getItem('access_token')
    ? localStorage.getItem('access_token')
    : process.env.VUE_APP_CONTROL_KEY
  try {
    if (immediate && store.state.userInfo && store.state.userInfo.id)
      await analyticsApi.post(
        urlAnalytics,
        {
          events: [
            {
              eventType,
              userId:
                store.state.userInfo && store.state.userInfo.id
                  ? store.state.userInfo.id
                  : guid(),
              payload,
              eventDate: moment().toDate()
            }
          ]
        },
        {
          headers: {
            Authorization: storageToken
          }
        }
      )
    else if (store.state.userInfo && store.state.userInfo.id)
      events.push({
        eventType,
        userId:
          store.state.userInfo && store.state.userInfo.id
            ? store.state.userInfo.id
            : guid(),
        payload,
        eventDate: moment().toDate()
      })
    if (
      events.length > maxEventsBatchAnalytics ||
      moment().diff(moment(lastEventFlush), 'minutes') >
        maxEventsTimeMinutesBatchAnalytics
    )
      await flushEvents()
    //if (process.env.VUE_APP_FEATURE_STAGE == 'prod')
    const r = gtag('event', eventType, payload)
    console.log(r)
  } catch (error) {
    console.log(error)
    console.log('Error  dispatching analytics events')
  }
}

async function flushEvents() {
  const storageToken = localStorage.getItem('access_token')
    ? localStorage.getItem('access_token')
    : process.env.VUE_APP_CONTROL_KEY
  const url = `${process.env.VUE_APP_BACKEND_URL}/analytics`
  if (events && events.length > 0) {
    await analyticsApi.post(
      url,
      { events },
      { headers: { Authorization: storageToken } }
    )
    events = []
    lastEventFlush = moment().toDate()
  }
}
